import { t } from "@lingui/core/macro";
import { errorText } from "./user-error";

/** The `data.code` an RPC billing error carries, when it has one. */
export function billingErrorCode(error: unknown): string | undefined {
  if (!error || typeof error !== "object") return undefined;
  const data = "data" in error ? (error.data as { code?: unknown } | null | undefined) : undefined;
  if (typeof data?.code === "string") return data.code;
  return "code" in error && typeof error.code === "string" ? error.code : undefined;
}

/** Copy for a billing failure; unknown ones fall back to the generic message. */
export function billingErrorText(error: unknown, fallback: string): string {
  switch (billingErrorCode(error)) {
    case "trial_already_used":
      return t`This trial was already used. Choose a plan to continue.`;
    case "trial_needs_verification":
      return t`Verify your phone or CPF to start the trial.`;
    case "trial_identification_not_saved":
      return t`Could not save your CPF, so the trial did not start. Try again.`;
    case "plan_not_on_sale":
      return t`This plan is not available.`;
    case "account_suspended":
      return t`This account is suspended. Contact support.`;
    case "rate_limited":
      return t`Too many attempts. Try again in a few minutes.`;
    default:
      return errorText(error, fallback);
  }
}

/** The plan's agent cap, when a refusal says the plan has no room for another bot. */
export function planAgentsLimit(error: unknown): { maxAgents: number } | null {
  if (billingErrorCode(error) !== "plan_agents_exceeded") return null;
  const data = (error as { data?: { maxAgents?: unknown } }).data;
  return typeof data?.maxAgents === "number" ? { maxAgents: data.maxAgents } : { maxAgents: 0 };
}
